import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { OrderMapsServices } from '@core/components/services/order-maps.services';
import { HttpParams } from '@angular/common/http';
import { OrderService } from '@accounts/user/services/order.service';
import { GridDataSource } from '@ui/grid-view';
import { MatSelect } from '@angular/material';
import { OrderModel } from '@core/api';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { pipe } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Component({
  selector: 'user-deals-list',
  templateUrl: './deals-list.component.html',
  styleUrls: ['./deals-list.component.scss']
})
export class UserDealsListComponent implements OnInit, AfterViewInit {

  @Input() allowedList: OrderModel.StatusEnum[] = [];

  @Input() filters: boolean = true;
  @Input() pagination: boolean = true;

  dataSource: OrderDataSource = null;

  @ViewChild('filter') filter: ElementRef;
  @ViewChild('status') status: MatSelect;

  statuses = this.orderMapsServices.STATUSES;

  allowedStatuses = [];

  constructor(
    public orderService: OrderService,
    private orderMapsServices: OrderMapsServices
  ) {
    moment.locale('ru');
   }

  groupByDate(orders: OrderModel[]) {
    moment.locale('ru');

    const grouped: Record<string, OrderModel[]> = {};

    orders.forEach(order => {
      const key = moment.utc(order.created_at, 'YYYY-MM-DD HH:mm:ss').local().format('YYYY-MM');
      grouped[key] = grouped[key] || [];
      grouped[key].push(order);
    });

    return Object.keys(grouped)
        .sort((a, b) => b.localeCompare(a))
        .map(key => ({
          month: moment(key, 'YYYY-MM').format('MMMM YYYY'),
          orders: grouped[key]
        }));
  }




  ngOnInit() {
    this.dataSource = new OrderDataSource(this.orderService, this.allowedList);
    this.dataSource.loadData((new HttpParams()).set('per_page', '100'));
   
   // this.hasData = this.dataSource.data.length > 0
/*
    Object.keys(this.statuses)
      .filter((status: OrderModel.StatusEnum) => {
        return this.allowedList.includes(status)
      })
      .forEach((status: OrderModel.StatusEnum) => {
        this.allowedStatuses[status] = this.statuses[status];
      });
      */
  }

  ngAfterViewInit() {
  /*  if (this.filters) {
      this.dataSource.addFilter({
        element: this.filter,
        queryName: 'q',
        eventName: 'keyup'
      });

      this.dataSource.addFilter({
        element: this.status,
        queryName: 'status[]'
      });
    }*/
  }

  update() {
    this.dataSource.loadData();
  }

}

export class OrderDataSource extends GridDataSource<OrderModel> {

  constructor(private orderService: OrderService, private allowedList: OrderModel.StatusEnum[]) {
    super();
  }

  loader(defaultHttpParams: HttpParams) {
    if(!defaultHttpParams.has('status[]')) {
      this.allowedList.forEach((status, key) => {
          defaultHttpParams = defaultHttpParams
            .set(`status[${key}]`, status)
      });
    }

    return this.orderService.getOrders(
      defaultHttpParams
    );
  }
}
